<mat-toolbar color="primary" class="mat-elevation-z0">
  <img
    routerLink="/"
    src="/assets/img/glimpse-logo.png"
    srcset="/assets/img/glimpse-logo.png, /assets/img/glimpse-logo@2x.png 2x"
    alt="Glimpse logo"
    class="company-logo"
    />

    <div class="location-buttons">
      @if ((locations$ | async).length <= 5) {
        @for (location of locations$ | async; track location) {
          <button
            mat-flat-button
            color="primary"
            [class.active]="location.id === (selectedLocationId$ | async)"
            (click)="selectLocation(location.id, location.name)"
            >
            <div class="non-unique-name">
              <div>{{ location.customer }}</div>
              <div>{{ location.name }}</div>
            </div>
          </button>
        }
      } @else {
        <app-location-picker (picked)="selectLocation($event.id, $event.name)"></app-location-picker>
      }
      @if ((featuresCount$ | async) > 0) {
        <button mat-flat-button color="primary" (click)="showOnboarding()" matTooltip="What's new?">
          <span class="header-icon"><mat-icon>info</mat-icon></span>
        </button>
      }
    </div>
    <span class="spacer"></span>
    @let alertBadge = settingsMenu.alertBadge$ | async;
    @if (alertBadge) {
      <button mat-flat-button color="primary" class="alerts-button" (click)="settingsMenu.goToDevices()" [matTooltip]="'Alerts' | translate">
        <span class="header-icon">
          <mat-icon [matBadge]="alertBadge" matBadgeColor="accent">notifications</mat-icon>
        </span>
      </button>
    }
    <button mat-flat-button color="primary" [matMenuTriggerFor]="settingsMenu.menu" [matTooltip]="'Settings' | translate">
      <span class="header-icon">
        <mat-icon>settings</mat-icon>
        @if (settingsMenu.missingAlertRecipient$ | async) {
          <span class="attention-dot"></span>
        }
      </span>
    </button>
    <app-settings-menu #settingsMenu></app-settings-menu>
    <button mat-flat-button color="primary" [matMenuTriggerFor]="accountMenu.menu" [matTooltip]="'Account' | translate">
      <span class="header-icon"><mat-icon>assignment_ind</mat-icon></span>
    </button>
    <app-account-menu #accountMenu></app-account-menu>
  </mat-toolbar>
